/**
 * The snippet a Mystic pastes on a partner site to syndicate their drops.
 *
 * It is the widget partners already run (Mystic-Aida-Fe-widgets, served from
 * the syndicate host). The Studio used to hand out an iframe to an /embed/
 * page this app never had. data-partner is what syndication analytics
 * report the site under.
 */
export const EMBED_SRC = 'https://syndicate.mysticaida.ai/embed.js'
const WIDGETS = ['drop', 'horoscope']

const attr = (v) => String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
  .replace(/</g, '&lt;').replace(/>/g, '&gt;')

export function embedSnippet(readerSlug, widget = 'drop') {
  const sub = attr(readerSlug || 'your-reader')
  const kind = WIDGETS.includes(widget) ? widget : 'drop'
  return `<script src="${EMBED_SRC}" data-widget="${kind}" data-reader="${sub}" data-partner="${sub}">`
    + '</' + 'script>'
}
